"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productStore = void 0;
var product_1 = require("./product");
Object.defineProperty(exports, "productStore", { enumerable: true, get: function () { return product_1.productStore; } });
//# sourceMappingURL=index.js.map